import { render } from "./PDFViewer.vue?vue&type=template&id=aab33562&scoped=true"
import script from "./PDFViewer.vue?vue&type=script&lang=js"
export * from "./PDFViewer.vue?vue&type=script&lang=js"

import "@/assets/css/components/PDFViewer.scss?vue&type=style&index=0&id=aab33562&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aab33562"]])

export default __exports__